<template>
  <div class="members-list">
    <div class="title">
      <div
        v-for="(item, index) in columns"
        :key="index"
        :class="['fl', item.key ]"
      >
        {{ item.title }}
      </div>
    </div>
    <ul v-if="!loading && memberList.length">
      <li
        v-for="(record, index) in memberList"
        :key="index"
        class="clearfix"
      >
        <div
          class="xiaoman fl"
        >
          {{ record.real_name }} | {{ record.email }}
        </div>
        <div
          class="westartrack fl"
        >
          <div
            v-show="!record.isEdit"
            class="con-box"
          >
            <span
              v-for="one in record.westartrackusers"
              :key="one.userid"
              class="user"
            >
              <i class="fs-12 fs-normal">{{ one.truename }}</i>
              <em class="fs-gray666 fs-12 fs-normal">
                [<i
                  v-for="(role, roleIndex) in one.roleinfo"
                  :key="role.roleid"
                  class="fs-normal"
                >{{ role.rolename }}{{ roleIndex > 0 ? '、' : '' }}
                </i>]
              </em>
            </span>
            <a
              class="btn-text"
              :class="{'edit-user-btn': record.westartrackusers.length}"
              @click="handleBindUser(record, index)"
            >{{ record.westartrackusers.length ? '修改' : '设置' }}</a>
          </div>
          <div
            v-show="record.isEdit"
            class="edit-box"
          >
            <a-select
              mode="multiple"
              :value="record.bindWestarUid"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              placeholder="请选择或者搜索"
              :get-popup-container="
                triggerNode => {
                  return triggerNode.parentNode || document.body;
                }
              "
              dropdown-class-name="bindWestarUid-select"
              @search="handleSearchUsers($event, record, index)"
              @change="handleChangeUsers($event, record, index)"
            >
              <!-- 下拉列表为空是，空提示 -->
              <div
                slot="notFoundContent"
                class="empty"
              >
                <i class="iconfont iconicon-test38" />
                暂无人员可对应
              </div>
              <!-- 人员被选择完了，空提示 -->
              <a-select-option
                v-if="newMemberOptions.length === 0"
                key="empty"
                class="empty"
              >
                <i class="iconfont iconicon-test38" />
                暂无人员可对应
              </a-select-option>
              <a-select-option
                v-for="one in memberOptions"
                :key="one.userid"
                :value="one.userid"
                :disabled="one.disabled"
                :class="{ hide: one.disabled }"
              >
                <span class="truename fs-12">{{ one.truename }}</span>
                <span
                  v-if="one.roleinfo"
                  class="role fs-gray fs-12"
                > [
                  <i
                    v-for="(role, roleIndex) in one.roleinfo"
                    :key="role.roleid"
                    class="fs-normal"
                  >{{ role.rolename }}{{ roleIndex > 0 ? '、' : '' }}</i>
                  ]
                </span>
              </a-select-option>
            </a-select>
            <a-button
              :loading="confirmLoading"
              type="primary"
              @click="handleConfrimBind(record, index)"
            >
              确定
            </a-button>
            <a-button @click="handleCancelBind(record, index)">
              取消
            </a-button>
          </div>
        </div>
      </li>
    </ul>
    <!-- 人员对应关系列表为空 -->
    <div
      v-if="!loading && !memberList.length"
      class="empty-box"
    >
      <i class="iconfont iconicon-test38 logo" />
      <p class="placeholder">
        暂无数据
      </p>
    </div>
    <a-spin
      v-if="loading"
      class="memberlist-loading"
    >
      <div class="spin-content">
        正在获取小满成员，请稍后…
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    memberOptions: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      confirmLoading: false,
      memberList: []
    }
  },

  computed: {
    ...mapState('config/xiaoman/baseConfig', ['columns']),

    allSelected () {
      let arr = []
      this.memberList.forEach((item = {}) => {
        let { bindWestarUid = [] } = item
        bindWestarUid.forEach(id => {
          if (!arr.includes(id)) {
            arr.push(id)
          }
        })
      })
      return arr
    },
    newMemberOptions () {
      let arr = []
      this.memberList.forEach(member => {
        let { isEdit, bindWestarUid = [] } = member || {}
        this.memberOptions.forEach(item => {
          if (!arr.includes(item)) {
            if (!item.disabled) {
              arr.push(item)
            } else if (isEdit) {
              bindWestarUid.forEach(id => {
                if (id === item.id) {
                  arr.push(item)
                }
              })
            }
          }
        })
      })

      return arr
    }
  },

  watch: {
    data: {
      handler (val) {
        if (!val) return

        let list = _.cloneDeep(val)
        this.memberList = this.setMemberList(list)
      },
      deep: true
    },
    memberOptions: {
      handler (val) {
        if (!val || !val.length) return

        this.memberList = this.setMemberList(this.data)
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('config/xiaoman', ['fetchXiaomanBaseInfo']),
    ...mapActions('config/xiaoman/baseConfig', ['setXiaomanUserBind']),

    setMemberList (list = []) {
      let { memberOptions = [] } = this

      for (let i = 0; i < list.length; i++) {
        let { bindWestarUid = [] } = list[i]

        list[i].isEdit = list[i].isEdit || false
        list[i].westartrackusers = []
        list[i].bindWestarUid = list[i].bindWestarUid.filter(item => {
          let id = parseInt(item)
          if (memberOptions.find(one => one.userid === id)) {
            return id
          }
        })

        list[i].westartrackusers = this.setWestartrackusers(bindWestarUid)
      }
      return _.cloneDeep(list)
    },

    setWestartrackusers (bindWestarUid) {
      let { memberOptions = [] } = this
      let westartrackusers = []
      for (let index = 0; index < bindWestarUid.length; index++) {
        for (let j = 0; j < memberOptions.length; j++) {
          if (memberOptions[j].userid === parseInt(bindWestarUid[index])) {
            westartrackusers.push(memberOptions[j])
          }
        }
      }
      return westartrackusers
    },

    async handleBindUser (record, index) {
      let { bindWestarUid = [] } = record

      record.bindWestarUid = record.bindWestarUid.filter(id => {
        if (this.memberOptions.find(one => one.userid === id)) {
          return id
        }
      })

      this.memberList.forEach(item => {
        item.isEdit = false
      })
      record.isEdit = true
      this.memberList.splice(index, 1, record)

      // 禁止下拉选项重复选择
      this.memberOptions.forEach(item => {
        item.disabled = false
        if (this.allSelected.length && this.allSelected.includes(item.userid) && !bindWestarUid.includes(item.userid)) {
          item.disabled = true
        }
      })
    },

    handleChangeUsers (value, record, index) {
      if (value.includes('empty')) {
        let i = value.findIndex(item => item === 'empty')
        value.splice(i, 1)
        return
      }
      record.bindWestarUid = value
      this.memberList[index].bindWestarUid = value
    },

    handleSearchUsers (value, record, index) {

    },

    filterOption (input, option) {
      let { componentOptions = {} } = option
      let { children = [] } = componentOptions
      let { elm = {} } = children[0]
      let { innerText } = elm
      return innerText.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    async updateBindUser (record = {}, index) {
      let chain = await this.setXiaomanUserBind({
        xiaomanuserid: record.user_id,
        weuserArr: record.bindWestarUid
      })
      chain
        .onSuccess(res => {
          this.confirmLoading = false
          this.memberList[index].isEdit = false
          this.memberList[index].westartrackusers = this.setWestartrackusers(record.bindWestarUid)
        })
    },

    handleConfrimBind (record, index) {
      if (this.confirmLoading) return

      this.confirmLoading = true
      this.updateBindUser(record, index)
    },

    handleCancelBind  (record, index) {
      this.$set(this.memberList[index], 'isEdit', false)
    }
  }
}
</script>

<style scoped lang="scss">
.members-list {
  padding: 24px 0;
}
.title {
  height: 48px;
  line-height: 48px;
  background: #F5F6F7;
  border: none;
  border-radius: 4px;
  .xiaoman, .westartrack {
    padding: 0 16px;
    font-weight: bold;
  }
}
.xiaoman {
  width: 320px;
}
.westartrack {
  width: 610px;
}
li {
  border-bottom: solid 1px #EBEBEB;
  .xiaoman {
    padding: 12px 16px;
  }
  .westartrack {
    padding: 0 16px;
    .ant-btn-primary {
      margin-left: 8px;
    }
    .edit-box {
      padding: 8px 0;
    }
    .con-box {
      padding: 12px 0 0;
    }
    .user {
      display: inline-block;
      padding: 2px 4px;
      margin-right: 6px;
      margin-bottom: 6px;
      line-height: 1;
      border: solid 1px #ebebeb;
      border-radius: 4px;
      &:last-of-type {
        margin-right: 8px;
      }
    }
  }
}
.empty-box {
  text-align: center;
  .logo {
    display: block;
    margin: 40px auto 8px;
    font-size: 24px;
    color: #d6d6d6;
  }
  .placeholder {
    margin-bottom: 16px;
    color: $gray3;
  }
}
.memberlist-loading {
  display: block;
  text-align: center;
  .ant-spin-blur {
    opacity: 1;
  }
  .spin-content {
    margin-top: 68px;
    color: #333;
  }
}
::v-deep .bindWestarUid-select {
  .hide {
    display: none;
  }
  .empty {
    text-align: center;
    color: #b3b3b3;
    .iconfont {
      display: block;
      margin: 10px 0 8px;
      text-align: center;
      color: #D6D6D6;
      font-size: 24px;
    }
    &.ant-select-dropdown-menu-item,
    &.ant-select-dropdown-menu-item:hover {
      background: none;
    }
    .ant-select-selected-icon {
      display: none;
    }
  }
  .ant-select-dropdown-menu-item-disabled:hover {
    background: none;
  }
}
</style>
